import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="min-h-screen bg-[#f5f5f5] dark:bg-slate-900 text-[#111011] dark:text-white px-4 sm:px-6 py-20 font-[Inter] transition-colors">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-[DM Sans] font-bold mb-6">
          Privacy Policy
        </h1>

        <p className="text-gray-600 dark:text-gray-300 mb-6 text-base">
          At Blackbear Technologies Inc. ("Blackbear," "we," "our," or "us"), your privacy is important to us. This Privacy Policy outlines how we collect, use, disclose, and protect your personal information.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">1. Information We Collect</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
          We collect information you provide directly to us, such as your name, email, and contact details when you fill out forms, subscribe to newsletters, or communicate with us. We also collect technical data like browser type, IP address, and usage behavior via cookies and analytics tools.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">2. How We Use Your Information</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
          We use the information we collect to:
        </p>
        <ul className="list-disc pl-6 text-sm text-gray-600 dark:text-gray-300 mb-4">
          <li>Respond to inquiries and provide customer support</li>
          <li>Improve and personalize our services</li>
          <li>Send updates, newsletters, and promotional materials (if opted-in)</li>
          <li>Monitor and analyze site usage and performance</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">3. Cookies and Tracking Technologies</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
          We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and deliver personalized content. You can control cookie settings through your browser preferences. By continuing to use our site, you consent to our use of cookies.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">4. Sharing Your Information</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
          We do not sell your personal information. We may share your data with trusted service providers who help us operate our business, and when required by law or legal process.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">5. Your Choices</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
          You may opt out of receiving marketing emails from us at any time by clicking the unsubscribe link in our emails. You may also disable cookies in your browser settings.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">6. Data Security</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
          We implement reasonable safeguards to protect your personal information. However, no method of transmission over the internet is 100% secure.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">7. Changes to This Policy</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
          We may update this policy periodically. Changes will be posted on this page with a revised effective date.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">8. Contact Us</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-2 text-sm">
          If you have any questions or concerns about this policy, please contact us at:
        </p>
        <p className="text-gray-600 dark:text-gray-300 text-sm">
          <strong>Email:</strong> <a href="mailto:support@blackbeartechnologies.ca" className="text-blue-700 dark:text-blue-400 hover:underline">support@blackbeartechnologies.ca</a><br />
          <strong>Address:</strong> Nanaimo, BC, Canada
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
